import React from 'react';
import { useAuth } from '../../../context/auth';
import {
  setShouldShowOTPModal,
  useOTPModalDismissable,
  useShouldShowOTPModal,
} from '../../../context/otpModal';
import { OTPModal } from '../OTPModal';

export function GlobalOTPModal() {
  const { isLogged } = useAuth();
  const shouldShowOTPModal = useShouldShowOTPModal();
  const dismissable = useOTPModalDismissable();

  if (!isLogged) return null;

  return (
    <OTPModal
      isOpen={shouldShowOTPModal}
      dismissable={dismissable}
      onClose={() => setShouldShowOTPModal(false)}
    />
  );
}
